import react from "react";


const INITIALSTATE = {
        loading :false,
        showBanner: false, 
        message: '',
        isSuccess:false
}

const LoadingReducer = (state = INITIALSTATE, action) => {
    switch (action.type) {
        case "LOADING":
            return { ...state, loading: action.data.Loading };
        case "SUCCESS":
            return { ...state, showBanner: true, message: action.data.Message, isSuccess:true };
        case "FAILURE":
            return { ...state, showBanner: true, message: action.data.Message, isSuccess:false };
        case "RESET":
            return INITIALSTATE;
        
        default: return state;

    };
}
export default LoadingReducer;